import React from "react";

const Inventory = ({ inventory }) => {
  const rarityColors = {
    common: "grey",
    uncommon: "green",
    rare: "blue",
    epic: "purple",
    legendary: "orange",
    mythic: "yellow"
  };

  return (
    <div className="inventory-list">
      {inventory.map((item, index) => (
        <div key={index} className="inventory-item">
          <img src={item.image} alt={item.name} />
          <p>{item.name}</p>
          <p className="rarity">
            Rarity: <span style={{ color: rarityColors[item.rarity.toLowerCase()] || "black" }}>
              {item.rarity}
            </span>
          </p>
        </div>
      ))}
    </div>
  );
};

export default Inventory;
